var x = y => { var x = {}; __webpack_require__.d(x, y); return x; }
var y = x => () => x
const __WEBPACK_NAMESPACE_OBJECT__ = x({ ["makeAutoObservable"]: () => __WEBPACK_EXTERNAL_MODULE_mobx__.makeAutoObservable, ["runInAction"]: () => __WEBPACK_EXTERNAL_MODULE_mobx__.runInAction });